import { createAction, createReducer } from '@reduxjs/toolkit';

import { Employee } from 'exit-interview.shared/models/dataModels/employee';
import { HttpMethod } from 'exit-interview.shared/constants/httpMethod';
import { InvitationState } from 'src/store/state/invitationState';
import { callApi } from 'src/utility/api';
import { createApiThunk } from 'src/types/reduxHelpers';

export const getEmployeeFromInvitationToken = createApiThunk<{ employee: Employee }, string>('/invitation/getEmployeeFromInvitationToken', async (invitationToken, thunkApi) => {
    const response = await callApi<{ employee: Employee }>(`/invitation/getEmployeeFromInvitationToken/${invitationToken}`);

    return response.data;
});


export const deleteInvitation = createApiThunk<void, string>('/invitation/deleteInvitationFromInvitationToken', async (invitationToken, thunkApi) => {
    const response = await callApi<void>(`/invitation/deleteInvitationFromInvitationToken/${invitationToken}`, HttpMethod.DELETE);

    return response.data;
});

export const resetInvitationState = createAction<void>('/invitation/reset');

const initialState: InvitationState = {
    isLoading: false,
    employee: undefined,
    token: undefined,
};

export const invitationReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(getEmployeeFromInvitationToken.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(getEmployeeFromInvitationToken.fulfilled, (state, action) => {
            state.isLoading = false;
            state.employee = action.payload.employee;
            state.token = action.meta.arg;
        })
        .addCase(getEmployeeFromInvitationToken.rejected, (state, action) => {
            state.isLoading = false;
            state.employee = undefined;
            state.token = undefined;
        })
        .addCase(deleteInvitation.pending, (state, action) => {
            state.isLoading = true;
        })
        .addCase(deleteInvitation.fulfilled, (state, action) => {
            state.isLoading = false;
        })
        .addCase(deleteInvitation.rejected, (state, action) => {
            state.isLoading = false;
        })
        .addCase(resetInvitationState, (state, action) => {
            // Never reassign the state object directly, i.e. state = initialState
            // Return the new value directly instead.
            // https://redux-toolkit.js.org/usage/immer-reducers#resetting-and-replacing-state
            return initialState;
        });
});